import { Money } from '@ap/interface-bspc-core';
import { CreditCard } from '@ap/ap-interface-apix-hypotheken-berekening';

export class CreditCardBuilder {
    private multipleInstallments: boolean;
    private amount?: Money;

    withAmount(amount: Money): this {
        this.amount = amount;
        return this;
    }

    withMultipleInstallments(multipleInstallments: boolean): this {
        this.multipleInstallments = multipleInstallments;
        return this;
    }

    build(): CreditCard {
        return {
            amount: this.amount,
            multiple_installments: this.multipleInstallments
        } as CreditCard;
    }
}
